import { INTERVIEW_FORMAT_TEMPLATE_MODEL } from "@/models/interview-format-template-model";
import JSONApiService from "@/services/JSONApiService";
import { ORGANISATION, include } from "@/models/relationships";

const organisationInterviewTemplateApi = commit => ({
  getAll: params =>
    JSONApiService(commit)
      .all(INTERVIEW_FORMAT_TEMPLATE_MODEL)
      .get({ ...include(ORGANISATION), ...params }),
  add: data =>
    JSONApiService(commit).create(INTERVIEW_FORMAT_TEMPLATE_MODEL, data),
  edit: data =>
    JSONApiService(commit)
      .one(INTERVIEW_FORMAT_TEMPLATE_MODEL, data.id)
      .patch(data)
});

export default organisationInterviewTemplateApi;
